import React from "react";
import { VStack, Heading } from "@chakra-ui/react";
import LabeledText from "../../Common/Layout/LabeledText";
import ContentCard from "../../Common/Layout/ContentCard";

const ClientData = ({ order }) => {
  return (
    <ContentCard w={["auto", "48%"]}>
      <Heading variant="h2">Información del Cliente</Heading>
      <VStack fontSize="0.9em" align="left">
        <LabeledText
          label="Nombre"
          text={`${order.businessName} (${order.zoneCode}${order.userId
            .toString()
            .padStart(5, "0")})`}
        ></LabeledText>
        <LabeledText label="Direccion" text={order.email}></LabeledText>
        <LabeledText
          label="Dirección de envío"
          text={order.address}
        ></LabeledText>
        <LabeledText label="Lista de precios" text={``}></LabeledText>
        {/* TODO Agregar Link */}
        <LabeledText
          label="Zona"
          text={`${order.zoneName} - ${order.zoneCode}`}
        ></LabeledText>
        <LabeledText label="Nota" text={`${order.comments}`}></LabeledText>
      </VStack>
    </ContentCard>
  );
};

export default ClientData;
